<template>
    <div>
        <app-page-header></app-page-header>

        <v-container grid-list-xl class="box">
            <v-layout row wrap align-center justify-center fill-height>
                <v-flex xs12 sm12 md10 lg8 xl5>

                    <v-card
                        class="camera-card"
                        elevation="2"
                    >
                        <div class="camera-header">
                            <div class="camera-name">
                                <v-icon
                                    small
                                    color="grey darken-1"
                                    class="mr-2"
                                >
                                    mdi-video
                                </v-icon>

                                Vrata
                            </div>

                            <div
                                v-if="videoUrl && !error"
                                class="live-status"
                            >
                                <span class="live-dot"></span>
                                LIVE
                            </div>
                        </div>

                        <div class="camera-video">

                            <img
                                v-if="videoUrl && !error"
                                :src="videoUrl"
                                alt="Vrata - Live video"
                                @error="handleStreamError"
                            />

                            <div
                                v-else-if="error"
                                class="camera-message"
                            >
                                <v-icon
                                    size="42"
                                    color="grey darken-1"
                                >
                                    mdi-video-off-outline
                                </v-icon>

                                <div class="camera-message-title">
                                    Video trenutno ni na voljo
                                </div>

                                <div class="camera-message-text">
                                    Povezave s kamero ni bilo mogoče vzpostaviti.
                                </div>

                                <v-btn
                                    text
                                    small
                                    color="primary"
                                    class="mt-2"
                                    @click="fetchStreamUrl()"
                                >
                                    <v-icon left small>
                                        mdi-refresh
                                    </v-icon>

                                    Poskusi ponovno
                                </v-btn>
                            </div>

                            <div
                                v-else
                                class="camera-message"
                            >
                                <v-progress-circular
                                    indeterminate
                                    color="grey lighten-1"
                                    size="32"
                                    width="3"
                                ></v-progress-circular>

                                <div class="camera-message-text mt-3">
                                    Vzpostavljam povezavo...
                                </div>
                            </div>

                        </div>
                    </v-card>

                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'VideoView',

    data: () => ({
        videoUrl: null,
        error: false
    }),

    methods: {
        fetchStreamUrl() {
            this.error = false
            this.videoUrl = null

            this.$store.commit(
                'SET_LOADER_TEXT',
                'Pridobivam video povezavo...'
            )

            this.$store.commit(
                'SET_LOADER',
                true
            )

            this.$store
                .dispatch('CCTV_URL')
                .then(response => {
                    this.videoUrl = response.data.video_url
                })
                .catch(err => {
                    window.console.error(err)
                    this.error = true
                })
                .finally(() => {
                    setTimeout(() => {
                        this.$store.commit(
                            'SET_LOADER_TEXT',
                            ''
                        )

                        this.$store.commit(
                            'SET_LOADER',
                            false
                        )
                    }, 500)
                })
        },

        handleStreamError() {
            this.error = true

            window.console.error(
                'Napaka pri prikazu CCTV streama.'
            )
        }
    },

    created() {
        this.$store.dispatch(
            'ROUTE_NAME',
            this.$route.name
        )
    },

    mounted() {
        this.fetchStreamUrl()
    }
}
</script>

<style scoped>
.camera-card {
    overflow: hidden;

    border-radius: 6px;

    transition:
        box-shadow 0.2s ease,
        transform 0.2s ease;
}

.camera-card:hover {
    box-shadow:
        0 4px 12px rgba(0, 0, 0, 0.12) !important;
}

.camera-header {
    height: 44px;

    padding: 0 14px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    background: #ffffff;

    border-bottom: 1px solid #eeeeee;
}

.camera-name {
    display: flex;
    align-items: center;

    font-size: 13px;
    font-weight: 500;

    color: #333333;
}

.live-status {
    display: flex;
    align-items: center;

    font-size: 9px;
    font-weight: 600;

    letter-spacing: 0.7px;

    color: #777777;
}

.live-dot {
    width: 6px;
    height: 6px;

    margin-right: 5px;

    border-radius: 50%;

    background: #e53935;

    box-shadow:
        0 0 0 2px rgba(229, 57, 53, 0.10);
}

.camera-video {
    position: relative;

    width: 100%;

    aspect-ratio: 16 / 9;

    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;

    background: #171717;
}

.camera-video img {
    display: block;

    width: 100%;
    height: 100%;

    object-fit: contain;
}

.camera-message {
    position: absolute;

    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 24px;

    text-align: center;

    color: #bdbdbd;
}

.camera-message-title {
    margin-top: 12px;

    font-size: 14px;
    font-weight: 500;

    color: #eeeeee;
}

.camera-message-text {
    margin-top: 5px;

    font-size: 11px;
    line-height: 1.5;

    color: #8f8f8f;
}

@media (max-width: 959px) {

    .camera-header {
        height: 42px;
    }

    .camera-card {
        border-radius: 4px;
    }
}
</style>